type Props = {
  CTA: string;
  onClick: Function;
  icon?: string;
};

const TagComponent = ({ CTA, onClick, icon = "" }: Props) => {
  return (
    <div className={`border flex  justify-center items-center text flex-nowrap whitespace-nowrap border-primary px-2 py-1 rounded-[7px] bg-white`} style={{width : '120px', height : '40px'}}>
      {icon !== "" && (
        <div className="flex w-5 h-5">
          <img className="w-5 h-5" src={icon} alt="" />
        </div>
      )}
      <div onClick={() => onClick()} className={`   w-fit text  whitespace-nowrap border-primary  rounded-[7px] bg-white cursor-pointer`}>
        <>
          <span className="w-full"> {CTA}</span>
        </>
      </div>
    </div>
  );
};

export default TagComponent;
